import { RouteObject } from "react-router-dom";
import { CrmPermissionsPage } from "@/pages/settings/crm/permissions";
import { CrmSharingRulesPage } from "@/pages/settings/crm/sharing-rules";

const CrmSettingsRoute: RouteObject[] = [
    {
        path: "crm/permissions",
        element: <CrmPermissionsPage />
    },
    {
        path: "crm/sharing-rules",
        element: <CrmSharingRulesPage />
    }
];

export default CrmSettingsRoute; 